import api from './api';

export const sambutanService = {
    // PUBLIC
    getPublicSambutan: async () => {
        try {
            const response = await api.get('/sambutan');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data'
            };
        }
    },

    // ADMIN
    getList: async () => {
        try {
            const response = await api.get('/sambutan-admin');
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    getDetail: async (id) => {
        try {
            const response = await api.get(`/sambutan-admin/${id}`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    create: async (formData) => {
        try {
            const response = await api.post('/sambutan-admin', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal menyimpan'
            };
        }
    },

    update: async (id, formData) => {
        try {
            const response = await api.post(`/sambutan-admin/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengupdate'
            };
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`/sambutan-admin/${id}`);
            return { success: true, message: response.data.message };
        } catch (error) {
            return { success: false, message: 'Gagal menghapus' };
        }
    },

    toggleActive: async (id) => {
        try {
            const response = await api.post(`/sambutan-admin/${id}/toggle-active`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengubah status' };
        }
    },
};

export default sambutanService;